import { render, staticRenderFns } from "./drugCategory.vue?vue&type=template&id=b2f822d4&scoped=true&"
import script from "./drugCategory.vue?vue&type=script&lang=js&"
export * from "./drugCategory.vue?vue&type=script&lang=js&"
import style0 from "./drugCategory.vue?vue&type=style&index=0&id=b2f822d4&lang=scss&scoped=true&"
import style1 from "./drugCategory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f822d4",
  null
  
)

export default component.exports